import { atom, selector } from 'recoil'
import { CrossVisitDate, CrossVisitPlaceDate, CrossVisitResponse, CrossVisitsByPlace } from 'src/common-services'
import { crossVisitClient } from 'src/clients'
import { keyFactory, retryAtom, uncachedSelector } from 'src/utils/recoil'
import { venueMatch } from 'src/atoms/search'
import { ifNotFound } from 'src/utils/ajax'

const key = keyFactory('insights-footfall-cross-visits')

export type CrossVisit = CrossVisitResponse & {
  venueId?: string
  address?: string
}

export const crossVisitsTab = atom<string>({
  key: key('cross-visits-active-tab'),
  default: 'venue',
})

export const crossVisitsPlacesDates = selector<Pick<CrossVisitDate, 'start'>[]>({
  key: key('cross-visits-places-dates'),
  get: ({ get }) => {
    get(retryAtom)
    return crossVisitClient.getPlacesDates()
  },
})

export const crossVisitsSelectedDate = atom<CrossVisitDate | undefined>({
  key: key('cross-visits-selected-date'),
  default: undefined,
})

export const otherCrossVisitsSelectedDate = atom<CrossVisitPlaceDate | undefined>({
  key: key('other-cross-visits-selected-date'),
  default: undefined,
})

export const otheCrossVisits = uncachedSelector<CrossVisitsByPlace[]>({
  key: key('other-cross-visits'),
  get: async ({ get }) => {
    const venue = get(venueMatch)
    if (!venue) {
      return []
    }
    const { venueId } = venue

    const date = get(otherCrossVisitsSelectedDate)
    if (!date) {
      return []
    }

    const visits = ifNotFound(() => crossVisitClient.getCrossVisitsByPlace({ venueId, start: date?.start }), [])
    return visits
  },
})
